import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { RiderEvent } from '@app/rest-client/faxe/models/rider-event';
import {
  addManyRiderEvents,
  patchManyRiderEvents,
  purgeRiderEvents
} from '@app/store/faxe/rider-event/rider-event.actions';
import { sapiensEntityState, SliceState } from '@app/store/faxe/sapiens-entity-state';

export const identifier = (a: RiderEvent): string => a.riderEventGuid;

export const adapter: EntityAdapter<RiderEvent> = createEntityAdapter<RiderEvent>({
  selectId: identifier
});

export type RiderEventEntityState = sapiensEntityState<RiderEvent>;

export const initialState: RiderEventEntityState = adapter.getInitialState({
  meta: {
    sliceState: SliceState.inital,
    timestamp: Date.now()
  }
});

const reducer = createReducer(
  initialState,
  on(addManyRiderEvents, (state, { models, sliceState }) => ({
    ...adapter.addMany(models, state),
    meta: {
      ...state.meta,
      sliceState,
      timestamp: Date.now()
    }
  })),
  on(patchManyRiderEvents, (state, { models }) => ({
    ...adapter.addMany(models, state),
    meta: {
      ...state.meta,
      timestamp: Date.now()
    }
  })),
  on(purgeRiderEvents, (state) => ({
    ...adapter.removeAll(state),
    meta: {
      ...state.meta,
      isReportable: undefined,
      timestamp: Date.now()
    }
  }))
);

export const riderEventReducer: (state: (RiderEventEntityState | undefined), action: Action) =>
  sapiensEntityState<RiderEvent> = (state: RiderEventEntityState | undefined, action: Action) =>
  reducer(state, action);

// get the selectors
const {
  selectAll
} = adapter.getSelectors();

// select the array of users
export const selectAllRiderEvent = selectAll;


